import { useTranslation } from 'react-i18next';
import { Card } from '../../../components/ui/card';
import { useTelegramBackButton } from '../../../utils/BackButton';
import { useGetDealsList } from '../../Promotion/services/getDealsList';
import { PromoCodesList } from '../../Promotion/ui/PromoCodesList';

export const Promocode = () => {
  const { t } = useTranslation();
  useTelegramBackButton('-1');

  const { promoCodes, isLoading } = useGetDealsList();

  return (
    <div className="flex h-full flex-col overflow-y-auto pb-safe-bottom pt-4">
      <p className="text-center text-display-sm text-text-primary">
        {t('promo')}
      </p>

      <div className="flex flex-col px-4 pt-6">
        {isLoading ? (
          <div className="flex flex-col space-y-3">
            {Array.from({ length: 4 }).map((_, index) => (
              <Card
                key={index}
                className="h-[140px] animate-pulse rounded-2xl border-none bg-fill-base shadow-none"
              />
            ))}
          </div>
        ) : null}

        {!isLoading && promoCodes.length ? (
          <PromoCodesList promoCodes={promoCodes} />
        ) : null}

        {!isLoading && !promoCodes.length ? (
          <div className="flex min-h-[300px] items-center justify-center">
            <p className="text-caption-sm-medium text-text-tertiary">
              {t('noPromo')}
            </p>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default Promocode;
